import { Box, Grid, GridProps } from '@mui/material'
import { HideableFieldProps, ContentWrapper, WrapperProps } from '.'

export type FieldWrapperProps = HideableFieldProps & GridWrapperProps

export const FieldWrapper = ({
  hidefield = false,
  children,
  gridProps
}: FieldWrapperProps) => {
  return (
    <ContentWrapper showContent={!hidefield}>
      <GridWrapper gridProps={gridProps}>{children}</GridWrapper>
    </ContentWrapper>
  )
}

export interface GridWrapperProps extends WrapperProps {
  gridProps: GridProps
}

export const GridWrapper = ({ children, gridProps }: GridWrapperProps) => {
  return (
    <Grid item {...gridProps} xs={gridProps.xs || 12}>
      <Box display="flex" flexDirection="column" flexGrow={1} flexShrink={1}>
        {children}
      </Box>
    </Grid>
  )
}
